// extracted by mini-css-extract-plugin
module.exports = {"wwtarvq":"wwtarvq"};